<template>
    <div class="block" v-loading="loading">
        <router-link class="link" :to="{name:'jackpotLog'}"><i class="el-icon-tickets"></i> 彩池记录</router-link>
        <el-tabs class="common-el-tabs" v-model="activeName" type="card">
            <el-tab-pane
                    v-for="(item,index) of JackpotList"
                    :key="item.jpType"
                    :label="item.jpName"
                    :name="'tab'+index">
                <comp-pool :info="item" @my-into='showPopup'/>
            </el-tab-pane>
        </el-tabs>
        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>注入确认</h3>
                <table class="common-popup-table">
                    <tr>
                        <td>注入金额：</td>
                        <td>
                            <el-input style="width: 180px" v-model="chip" size="medium" type="number"></el-input>
                            金豆
                        </td>
                    </tr>
                    <tr>
                        <td>营销账户余额：</td>
                        <td v-text="marketingAccountFund/100+'金豆'"></td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" @click="close">取消</el-button>
                    <el-button size="small" @click="submit" type="primary">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import compPool from './compPool'

    export default {
        components: {
            compPool
        },
        data() {
            return {
                loading: false,
                activeName: 'tab0',
                show: false,
                chip: '',
                poolId: null,
                marketingAccountFund: 0,
            }
        },
        computed: {
            ...mapState('jackpot', ['JackpotList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('jackpot', ['getJackpotList', 'setJackpotChip']),
            getList() {
                this.loading = true;
                this.getJackpotList().then(() => {
                    this.loading = false
                })
            },
            showPopup({poolId, marketingAccountFund}) {
                this.poolId = poolId;
                this.marketingAccountFund = marketingAccountFund;
                this.show = true;
            },
            submit() {
                if (!this.chip) {
                    this.$message.info('请输入金豆数');
                    return
                }
                this.setJackpotChip({
                    chip: this.chip,
                    poolId: this.poolId
                }).then(() => {
                    this.$message.success('注入成功');
                    this.close()
                })
            },
            close() {
                this.show = false;
                this.chip = '';
                this.poolId = null;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .block{
        padding-bottom: 0;
    }
    .link {
        position: absolute;
        right: 40px;
        z-index: 1;
        color: $theme-color;
        &:hover {
            transform: translateY(1px);
        }
    }

    .common-el-tabs {
        :global(.el-tabs__header) {
            margin-bottom: 0;
        }
        :global(.el-tabs__content) {
            margin: 0 -20px;
            padding: 0 20px 0;
        }
        :global(.el-collapse-item__header) {
            position: relative;
            padding: 0 20px;
            font-size: 18px;
            background: linear-gradient($bg-color, #fff);
        }
        :global(.el-collapse) {
            margin-bottom: 20px;
        }
    }


</style>